import * as React from 'react';

/** A ref holding the newest value, assigned in a layout effect, for handlers that must stay referentially stable. */
export const useLatestRef = <T>(value: T): React.MutableRefObject<T> => {
    const ref = React.useRef(value);

    React.useLayoutEffect(() => {
        ref.current = value;
    }, [value]);

    return ref;
};
